<template>
    <div @click.prevent="open" class="flex space-x-4 cursor-pointer">
        <slot name="button" />
    </div>

    <modal v-model="show">
        <template #header>
            <slot name="header" />
        </template>
        <slot name="content" />
    </modal>
</template>

<script>
import Modal from '@/components/shared/Modal'

export default {
    data() {
        return {
            show: false
        }
    },
    methods: {
        open() {
            this.show = true
        }
    },
    components: {
        Modal
    }
}
</script>
